import { FormattedMessage } from "react-intl";

export const translate = (id, values) => {
  // Handle cases where id is undefined, null, or empty
  if (!id || typeof id !== 'string' || id.trim() === '') {
    console.warn('translate() called with invalid id:', id);
    return <FormattedMessage id="fruitX" defaultMessage="FruitX" values={values} />;
  }
  return <FormattedMessage id={id} defaultMessage={id} values={values} />;
};

export const languageFormatter = translate;
